import script from "./ModelClassOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModelClassOverlay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import TouchHold from 'quasar/src/directives/touch-hold/TouchHold.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QScrollArea});qInstall(script, 'directives', {TouchHold});
